import { useTranslation } from 'react-i18next';
import { Alert, Button, LinearProgress, Stack } from '@mui/material';

import { PASSWORD_CHANGE_SUCCESS_TIMEOUT_MS } from './useSuccessCountdown';

type SuccessStepProps = {
  remainingMs: number;
  onFinished: () => void | Promise<void>;
};

export function SuccessStep({ remainingMs, onFinished }: SuccessStepProps) {
  const { t } = useTranslation();

  return (
    <Stack sx={{ width: '100%', gap: 2 }} data-qa-element-id="password-change-success-step">
      <Alert severity="success">{t('login.passwordChangeV3.successMessage')}</Alert>
      <Button
        type="button"
        fullWidth
        variant="contained"
        color="secondary"
        onClick={() => void onFinished()}
        data-qa-element-id="password-change-login-button"
      >
        {t('login.passwordChangeV3.loginButton')}
      </Button>
      {/* The reversed determinate bar shows how much time remains before automatic logout. */}
      <LinearProgress
        variant="determinate"
        value={(remainingMs / PASSWORD_CHANGE_SUCCESS_TIMEOUT_MS) * 100}
        aria-label={t('login.passwordChangeV3.timeIndicator')}
        data-testid="password-change-success-time-indicator"
        data-qa-element-id="password-change-success-time-indicator"
        sx={{
          width: '100%',
          height: 4,
          borderRadius: 2,
          backgroundColor: 'grey.300',
          transform: 'scaleX(-1)',
          '& .MuiLinearProgress-bar': { backgroundColor: 'secondary.light' },
        }}
      />
    </Stack>
  );
}
